import React, { useState, useEffect } from "react";
import { Box, Typography, Tabs, Tab, CircularProgress, TextField, Button } from "@mui/material";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Reports() {
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [salesSource, setSalesSource] = useState([]);
    const [estimateSource, setEstimateSource] = useState([]);
    const [paymentSource, setPaymentSource] = useState([]);
    const [purchaseSource, setPurchaseSource] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    useEffect(() => {
        fetchProductData();
    }, []);
    const fetchProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product-report/category-wise-summary";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "product-sales";
            const response = await makeRequest("get", url);
            if (response) {
                setSalesSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "product-estimate";
            const response = await makeRequest("get", url);
            if (response) {
                setEstimateSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "payments/all";
            const response = await makeRequest("get", url);
            if (response) {
                setPaymentSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        try {
            let url = webEndPoint + "product-purchase";
            const response = await makeRequest("get", url);
            if (response) {
                setPurchaseSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchStockReport = async () => {
        try {
            setLoading(true);
            let url = webEndPoint + "product-report/category-wise-summary";
            if (fromDate && toDate) {
                url += `?fromDate=${fromDate}&toDate=${toDate}`;
            }
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const getReportData = () => {
        switch (tab) {
            case 0:
                return {
                    columns: ["S.No", "Purchase No", "Date", "Supplier Name", "Total Amount (₹)"],
                    rows: purchaseSource.map((p, i) => [i + 1, p.rfId, formatDate(p.purchase_date), p.supplier_name, p.total_amount])
                };
            case 1:
                return {
                    columns: ["S.No", "Estimate No", "Date", "Customer", "Total"],
                    rows: estimateSource?.map((o, i) => [i + 1, o.rfId, formatDate(o.estimate_date), o.customer_name, `₹${o.grand_total?.toLocaleString()}`])
                };
            case 2:
                return {
                    columns: ["S.No", "Invoice No", "Date", "Customer", "Total Amount"],
                    rows: salesSource?.map((inv, i) => [i + 1, inv.rfId, formatDate(inv.sales_date), inv.customer_name, `₹${inv.grand_total?.toLocaleString()}`])
                };
            case 3:
                return {
                    columns: ["S.No", "Category", "Purchase Amount", "Sales Amount", "Balance Amount"],
                    rows: dataSource?.categories?.map((s, i) => [i + 1, s.category_name, s.purchase_amount, s.sales_amount, s.balance_amount])
                };
            case 4:
                return {
                    columns: ["S.No", "User", "Plan", "Due No", "Paid Amount (₹)", "Payment Date", "Payment Type", "Paymnet Status", "Reference No"],
                    rows: paymentSource.map((p, i) => [i + 1, p.user_name, p.saving_plan_name, p.installment_no, p.amount_paid, formatDate(p.payment_date), p.payment_method, p.payment_status, p.transaction_reference])
                };
            default:
                return { columns: [], rows: [] };
        }
    };
    const { columns, rows } = getReportData();
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3 }}>Reports</Typography>
            <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label="Purchase Report" />
                <Tab label="Estimate Report" />
                <Tab label="Invoice Report" />
                <Tab label="Stock Report" />
                <Tab label="Plan Payment Report" />
            </Tabs>
            {tab === 3 && (
                <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2, flexWrap: "wrap" }}>
                    <TextField label="From Date" type="date" size="small" InputLabelProps={{ shrink: true }} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    <TextField label="To Date" type="date" size="small" InputLabelProps={{ shrink: true }} value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    <Button variant="contained" onClick={fetchStockReport}>View</Button>
                    <Button variant="outlined" onClick={() => { setFromDate(""); setToDate(""); fetchStockReport(); }}>Reset</Button>
                </Box>
            )}
            <DataTable columns={columns} rows={rows} loading={false} />
        </Box>
    );
}